<mat-form-field subscriptSizing="dynamic">
  <mat-label>{{ label }}</mat-label>
  <mat-select
    [formControl]="statusControl"
    multiple
    panelClass="searchbar-list StatusHygieneComponent__Panel"
  >
    <mat-option
      *ngFor="let statusItem of inspectionStatuses"
      [value]="statusItem"
    >
      {{ 'inspections.statusHygiene.' + statusItem + '.text' | enum }}
    </mat-option>
  </mat-select>
</mat-form-field>
